import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { Container, Draggable } from 'react-smooth-dnd'
import uniqid from 'uniqid';
import { dispatch } from '@rematch/core';
import Loader from './Loader'
import Card from './Card'
import NewCard from './NewCard'
import { AddCardLink, LaneFooter, ScrollableLane, Section } from '../../styles/Base'
import { toastr } from 'react-redux-toastr';
import * as laneActions from '../actions/LaneActions'
import { CollapseBtn, ExpandBtn } from '../../styles/Elements'
import { Button, Icon } from "semantic-ui-react";
import PlaybookActivityCard from '../../../cards/PlaybookActivityCard'

class Lane extends Component {
  state = {
    loading: false,
    currentPage: this.props.currentPage,
    addCardMode: false,
    collapsed: false,
    isDraggingOver: false,
    objectId: ''
  }

  handleScroll = evt => {
    const node = evt.target
    const elemScrolPosition = node.scrollHeight - node.scrollTop - node.clientHeight
    const { onLaneScroll } = this.props
    if (elemScrolPosition <= 0 && onLaneScroll && !this.state.loading) {
      const { currentPage } = this.state
      this.setState({ loading: true })
      const nextPage = currentPage + 1
      onLaneScroll(nextPage, this.props.id).then(moreCards => {
        if (!moreCards || moreCards.length === 0) {
          // if no cards present, stop retrying until user action
          node.scrollTop = node.scrollTop - 100
        } else {
          this.props.actions.paginateLane({
            laneId: this.props.id,
            newCards: moreCards,
            nextPage: nextPage
          })
        }
        this.setState({ loading: false })
      })
    }
  }

  sortCards(cards, sortFunction) {
    if (!cards) return []
    if (!sortFunction) return cards
    return cards.concat().sort(function (card1, card2) {
      return sortFunction(card1, card2)
    })
  }

  laneDidMount = node => {
    if (node) {
      node.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.cards, nextProps.cards)) {
      this.setState({
        currentPage: nextProps.currentPage
      })
    }
  }


  handleLaneheaderClick = (e, card) => {
    // Stage click
    if (!this.props.enableLinkActivity) {
      dispatch.lifeCycle.disableLinking();
      dispatch.createPack.showDuplicateIcon(true);
      dispatch.lifeCycle.showResourecePane("PracticeCommunitySwimLineCommanPane")
      dispatch.lifeCycle.splitAt("60%");
      dispatch.createPack.getSelectedActivityAsync(card)
      dispatch.createPack.activityUniqueIdSet(card)

    }
  }

  showEditableCard = () => {

    this.setState({ addCardMode: true, objectId: this.props.objectId });
    this.props.setCurrentLane(this.props.title, this.props.objectId);
    dispatch.initiatives.setIdToCenterPosition(null);
    dispatch.createPack.activityUniqueIdSet(null);
    dispatch.createPack.setSelectedActivityData({});
    dispatch.createPack.addActivityModalOpen(true);
  }

  hideEditableCard = () => {
    this.setState({ addCardMode: false })
  }

  addNewCard = params => {
    const laneId = this.props.id
    const id = uniqid();
    const boardId = this.props.boardId;
    this.hideEditableCard()
    let card = { ...params, id, boardId }
    this.props.onCardAdd(card, laneId)

    const nodeToAdd = {
      name: params.title,
      description: params.description,
      packId: this.props.selectedPracticeLibrary._id,
      branchID: this.props.branchID,
      lastUpdatedBy: this.props.user,
      parentActivity: this.props._id,
      isLeafNode: true,
      accountId: this.props.selectedPracticeLibrary.accountId,
      organizationId: this.props.selectedPracticeLibrary.organizationId
    }
    dispatch.lifeCycle.createActivity(nodeToAdd)
  }

  renderAddCardLink = () => {
    const { addCardLink } = this.props
    if (addCardLink) {
      return <span onClick={this.showEditableCard}>{addCardLink}</span>
    } else {
      return <AddCardLink onClick={this.showEditableCard}>Add Card</AddCardLink>
    }
  }

  renderNewCard = () => {
    const { newCardTemplate, id } = this.props
    if (newCardTemplate) {
      const newCardWithProps = React.cloneElement(newCardTemplate, {
        onCancel: this.hideEditableCard,
        onAdd: this.addNewCard,
        laneId: id
      })
      return <span>{newCardWithProps}</span>
    } else {
      return <NewCard {...this.props} onCancel={this.hideEditableCard} onAdd={this.addNewCard} />
    }
  }

  onDragStart = (id, payload) => {
    if (payload.type === "activity") {
      dispatch.lifeCycle.showResourecePane(null);
    }
    const { handleDragStart } = this.props
    handleDragStart && handleDragStart(payload.id, payload.laneId, payload.boardId)
  }

  shouldAcceptDrop = sourceContainerOptions => {
    const accessDrop = this.props.droppable &&
      (sourceContainerOptions.groupName === 'TrelloLane' || sourceContainerOptions.groupName === 'Activity')

    return accessDrop
  }

  onDragEnd = (laneId, result) => {
    
    // keys should be greater than 0
    if(result.addedIndex !== null && this.props.integration &&  Object.keys(this.props.integration).length >0){
      toastr.warning('Smart Stage', 'You cannot drag new activity in smart stage.');
      return false;
    }
    this.setState({ isDraggingOver: false })
    const { handleDragEnd, boardId } = this.props;
    const { addedIndex, payload } = result;
    if (addedIndex != null) {
      if (payload.type === "activity") {
        handleDragEnd && handleDragEnd(payload.id, payload.type, laneId, addedIndex, payload);
        delete payload._id;
        payload.activities = [];
        payload.dependencies = [];
        payload.notes = [];
        delete payload.raci;
        payload.attachments = [];
        payload.parentActivity = laneId;
        payload.packId = this.props.selectedPracticeLibrary._id;
        payload.branchID = this.props.selectedPracticeLibrary.branches[0];
        payload.accountId = this.props.selectedPracticeLibrary.accountId;
        payload.organizationId = this.props.selectedPracticeLibrary.organizationId;

        dispatch.createPack.createCopyAndPushToActivity({ nodeToAdd: payload, target: laneId, indexInTarget: addedIndex, selectedPracticeLibrary: this.props.selectedPracticeLibrary._id })
      } else {
        payload.parentActivity = payload.laneId;
        let moveObject = Object.assign({}, payload);
        dispatch.createPack.changeActivityIndex({ nodeToMove: moveObject, target: laneId, indexInTarget: addedIndex, selectedPracticeLibrary: this.props.selectedPracticeLibrary._id });
        this.props.actions.moveCardAcrossLanes({
          fromBoardId: payload.boardId,
          fromLaneId: payload.laneId,
          toBoardId: boardId,
          toLaneId: laneId,
          cardId: payload._id,
          index: addedIndex,
          communityTagColor: payload.communityTagColor,
          duration: payload.duration
        })

        handleDragEnd && handleDragEnd(payload._id, payload.laneId, laneId, addedIndex, payload)
      }
    }

  }

  renderDragContainer = isDraggingOver => {

    const {
      laneSortFunction,
      editable,
      hideCardDeleteIcon,
      tagStyle,
      cardStyle,
      draggable,
      cardDraggable,
      cards,
      cardDragClass,
      objectId
    } = this.props
    const { addCardMode, collapsed } = this.state
    const showableCards = collapsed ? [] : cards
    const cardList = this.sortCards(showableCards, laneSortFunction).map((card, idx) => {
      if (card) {
        const cardToRender = (
          <Card
            id={card._id}
            cardDetail={card}
            key={card._id}
            index={idx}
            customCardLayout={this.props.customCardLayout}
            customCard={this.props.children}
            tagStyle={tagStyle}
            cardStyle={cardStyle}
            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
            removeEdge={this.props.removeEdge}
            editable={editable}
            hideCardDeleteIcon={hideCardDeleteIcon || this.props.enableLinkActivity}
            boardId={this.props.boardId}
            className={` `}
            enableLinkActivity={this.props.enableLinkActivity}
            selectedActivity={this.props.selectedPracticeFlowActivity}
            cycles={this.props.selectedPracticeLibrary.cycles}
            {...card}
            communities={this.props.selectedPracticeLibrary.communities}
            user={this.props.user}
            currentOrganization={this.props.currentOrganization}
          />
        )
        return draggable && cardDraggable ? (
          <Draggable title="" key={card._id}>{cardToRender}</Draggable>
        ) : <span key={card._id}>{cardToRender}</span>

      }

    })
    let setHeight;
    let height = this.props.componentDesignerDimension;
    let cutHeight = height.windowHeight - height.height;
    if (this.props.selectedPracticeLibrary.status === 0) {
      if (this.props.title === 'Others') {
        setHeight = cutHeight - 290
      } else {
        setHeight = cutHeight - 420
      }
    } else {
      if (this.props.title === 'Others') {
        setHeight = cutHeight - 290
      } else {
        setHeight = cutHeight - 387
      }
    }

    return (
      <ScrollableLane innerRef={this.laneDidMount} isDraggingOver={isDraggingOver}>
        <Container
          orientation="vertical"
          groupName="TrelloLane"
          dragClass={cardDragClass}
          onDragStart={e => this.onDragStart(objectId, e)}
          onDrop={e => this.onDragEnd(objectId, e)}
          onDragEnter={() => this.setState({ isDraggingOver: true })}
          onDragLeave={() => this.setState({ isDraggingOver: false })}
          shouldAcceptDrop={this.shouldAcceptDrop}
          style={{ maxHeight: setHeight }}
          className="overflow-hide"
          getChildPayload={index => this.props.getCardDetails(this.props.objectId, index)}>
          {cardList}
        </Container>
        {this.props.selectedPracticeLibrary.status === 0 &&
        ((this.props.integration &&
        Object.keys(this.props.integration).length === 0 )|| (!this.props.integration))? (
          this.props.title === "Others" ? (
            <span></span>
          ) : (
            <Button
              className="buttonAdd"
              onClick={this.showEditableCard}
              fluid
              icon="plus"
              title={"Add Activity under Stage"}
            ></Button>
          )
        ) : null}
        {addCardMode}
      </ScrollableLane>
    )
  }

  renderHeader = () => {
    const { customLaneHeader } = this.props;
    if (customLaneHeader) {
      const customLaneElement = React.cloneElement(customLaneHeader, { ...this.props })
      return <span>{customLaneElement}</span>
    } else {
      const { title, cards } = this.props;
      return (
        <div title="" >
          <div
            onClick={e => this.handleLaneheaderClick(e, this.props.objectId)}
            onDoubleClick={this.doubleClickOnActivity}
            style={{ "cursor": "pointer", 'width': "200px", 'margin': "3px" }}
          >
            {title !== "Others" ?
              <PlaybookActivityCard
                type="stage"
                page="sequence"
                selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                activityData={this.props.stageData}
                selectedActivity={this.props.selectedPracticeFlowActivity}
                enableLinkActivity={this.props.enableLinkActivity}
                _id={this.props.id}
                communities={this.props.selectedPracticeLibrary.communities}
                removeEdge={this.props.removeEdge}
                user={this.props.user}
                currentOrganization={this.props.currentOrganization}
              /> : null}
          </div>

          <div className="activityCount" onClick={this.toggleLaneCollapsed}>
            <Icon name={this.state.collapsed ? "angle right" : "angle down"} className="vert_middle" /><span>{cards ? cards.length : ''}</span> Activities
          </div>
        </div>
      )
    }
  }

  renderFooter = () => {
    const { collapsibleLanes, cards } = this.props
    const { collapsed } = this.state
    if (collapsibleLanes && cards && cards.length > 0) {
      return <LaneFooter onClick={this.toggleLaneCollapsed}>{collapsed ? <ExpandBtn /> : <CollapseBtn />}</LaneFooter>
    }
  }

  toggleLaneCollapsed = () => {
    this.props.collapsibleLanes && this.setState(state => ({ collapsed: !state.collapsed }))
  }

  render() {
    const { loading, isDraggingOver } = this.state
    const { id, onLaneClick, ...otherProps } = this.props

    let stage = this.renderHeader()
    return (
      <Section title="" className={otherProps.isDummy ? 'no-stage-added' : null} {...otherProps} key={id} onClick={() => onLaneClick && onLaneClick(id)} draggable={false} style={{"cursor":"grab"}}>
        {stage}
        {this.renderDragContainer(isDraggingOver)}
        {loading && <Loader />}
        {this.renderFooter()}
      </Section>
    )
  }
}

Lane.defaultProps = {
  style: {},
  titleStyle: {},
  labelStyle: {},
  label: undefined,
  editable: false,
  onCardAdd: () => { }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(laneActions, dispatch)
})

export default connect(null, mapDispatchToProps)(Lane)
